<template>
    <div class="ice-notify">
        <div class="close" @click="$thisFrame.close">X</div>
        <div class="template-normal">
            <div class="title">
                {{ title }}
            </div>
            <div class="content">
                {{ content }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: Boolean,
        title: {
            type: String,
            default: '提示信息'
        },
        content: String,
        timeout: {
            type: Number,
            default: 2000
        }
    },
    data: _=>({
        time: -1
    }),
    mounted() {
        this.time = setTimeout(_=>{
            this.$thisFrame.close(false,'timeout')
        },this.timeout)

        this.$thisFrame.watchShow((newData)=>{
            if (!newData)
                clearTimeout(this.time)
            else 
                this.time = setTimeout(_=>{
                    this.$thisFrame.close(false,'timeout')
                },this.timeout)
        })
    }
}
</script>

<style scoped>
    .ice-notify {
        width: 260px;
        height: 100px;
        border-radius: 5px;
        margin: 10px;

        background-color: rgba(255, 255, 255, .86);
        
        box-shadow: 0 0 .3em rgba(0,0,0,.1);
    }

    .title {
        padding: 10px;
        font-weight: 800;
    }

    .content {
        padding: 5px 20px;
    }

    .close {
        margin: 10px 10px 0 0;
        cursor: pointer;

        user-select: none;
    }

    .top-left {
        top: 10px;
        left: 10px;
    }

    .top-right {
        top: 10px;
        right: 10px;
    }

    .bottom-left {
        bottom: 10px;
        left: 10px;
    }

    .bottom-right {
        bottom: 10px;
        right: 10px;
    }

    .close {
        position: absolute;
        top: 10px;
        right: 10px
    }
</style>